import { createSelector } from 'reselect';
import { getCoreState } from '../selectors';

export const FORM_STATE_ROOT = 'forms';

const getState = createSelector(
    [getCoreState],
    (coreState) => coreState[FORM_STATE_ROOT]
);
